// UsageDataChecker feature — query-key gyár. A tényleges hívásokat a route a tipizált ts-rest kliensen
// (`api.serviceUsageList` / `api.currencyRatesList` / `api.currencyRateUpsert`) intézi; a kulcsok itt élnek.

/** A usage-lista szűrői (a query-kulcs része — szűrő-váltás új cache-bejegyzést nyit). */
export interface UsageListFilters {
  year: number;
  month: number;
  sourceType: string;
  /** Hozzárendelés-szűrő (`missing` → csak a mért, de be nem sorolt sorok; különben mind). */
  assignment: string;
  q: string;
}

/** Query-kulcs gyár — a usage-lista + az árfolyam-lista cache egységes címzése (invalidálás). */
export const usageKeys = {
  all: ['usage-data'] as const,
  usageLists: () => ['usage-data', 'usage'] as const,
  usageList: (filters: UsageListFilters) => ['usage-data', 'usage', filters] as const,
  rates: () => ['usage-data', 'rates'] as const,
};
